module.exports = __webpack_public_path__ + "static/img/花瓶13.a103c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶13.png
// module id = Rzf8
// module chunks = 2